import { useLocation } from "react-router-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
// import { hasPermission } from "../../../utils/commonfunction";
import logo from "../../../assets/Discount_App_logo.png";
import { useTranslation } from "react-i18next";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.parentElement;
    if (dropDown.classList.contains("show")) {
      dropDown.classList.remove("show");
    } else {
      dropDown.classList.add("show");
    }
  };

  const hoverSidebar = (e) => {
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = (e) => {
    $("body").removeClass("main-sidebar-open");
  };

  console.log(loc.pathname.includes("/manage-categories/sub-categories"));

  return (
    <div className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y" id="app_sidebar" onMouseEnter={hoverSidebar} onMouseLeave={removeHoverSidebar}>
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          <img src={logo} className="header-brand-img icon-logo" alt="logo" style={{ height: "2.4rem", width: "2.4rem", objectFit: "contain" }} id="logo_short" />
          <img src={logo} className="header-brand-img desktop-logo rounded" style={{ height: "3.2rem", maxHeight: "60px", width: "auto", objectFit: "contain" }} alt="logo" id="logo_full" />
        </a>
      </div>
      {/* Dashboard section start */}
      <div className="main-sidebar-body">
        <ul className="nav">
          <li className={"nav-item" + (loc.pathname === "/admin/dashboard" ? " active" : "")}>
            <Link className="nav-link" to="/admin/dashboard">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-home sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_dashboard")}</span>
            </Link>
          </li>
          {/* Dashboard section end */}

          <li className={`nav-item ` + (loc.pathname.includes("/user") ? "show active" : "")}>
            <Link className="nav-link" to={`/admin/user/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-user sidemenu-icon"></i>
              <span className="sidemenu-label">User Management</span>
            </Link>
          </li>

          <li className={`nav-item ` + (loc.pathname.includes("/business") ? "show active" : "")}>
            <Link className="nav-link" to={`/admin/business/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">Business</span>
            </Link>
          </li>

          <li className={`nav-item ` + (loc.pathname.includes("/rating") ? "show active" : "")}>
            <Link className="nav-link" to={`/admin/rating/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">Rating</span>
            </Link>
          </li>

          {/* Cms section start */}
          {/* {hasPermission("/admin/cms") ? ( */}
          <li className={`nav-item ` + (loc.pathname.includes("/cms") ? "show active" : "")}>
            <a className="nav-link with-sub submenu" onClick={toggleDropdown} href={"/"}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-edit sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className={`nav-sub-item ${loc.pathname.includes("/cms/pages") ? " active" : ""}`}>
                <Link className="nav-sub-link" to={`/admin/cms/pages/list/${1}`}>
                  {t("sidebar_link_pages")}
                </Link>
              </li>
              <li className={`nav-sub-item ${loc.pathname.includes("/cms/banner") ? " active" : ""}`}>
                <Link className="nav-sub-link" to={`/admin/cms/banner/list/${1}`}>
                  {t("sidebar_link_banners")}
                </Link>
              </li>
              {/* <li
                  className={`nav-sub-item ${loc.pathname.includes("/cms/faq") ? " active" : ""
                    }`}
                >
                  <Link
                    className="nav-sub-link"
                    to={`/admin/cms/faq/list/${1}`}
                  >
                    {t("FAQ")}
                  </Link>
                </li> */}
              <li className={"nav-sub-item" + (loc.pathname.includes("/cms/default-email-template") ? " active" : "")}>
                <Link className="nav-sub-link" to={`/admin/cms/default-email-template/list/${1}`}>
                  {t("sidebar_link_email_template")}
                </Link>
              </li>

              <li className={"nav-sub-item" + (loc.pathname.includes("/cms/default-sms-template") ? " active" : "")}>
                <Link className="nav-sub-link" to={`/admin/cms/default-sms-template/list/${1}`}>
                  {t("sidebar_link_sms_template")}
                </Link>
              </li>

              <li className={"nav-sub-item" + (loc.pathname.includes("/cms/settings") ? " active" : "")}>
                <Link className="nav-sub-link" to={`/admin/cms/settings`}>
                  {t("sidebar_link_global_settings")}
                </Link>
              </li>
            </ul>
          </li>

          <li className={`nav-item ` + (loc.pathname.includes("/manage-categories") ? "show active" : "")}>
            <a className="nav-link with-sub submenu" onClick={toggleDropdown} href={"/"}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i class="fa fa-th-large sidemenu-icon" aria-hidden="true"></i>
              <span className="sidemenu-label">{t("sidebar_link_manage_categories")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className={`nav-sub-item ${loc.pathname.includes("/manage-categories/categories") ? " active" : ""}`}>
                <Link className="nav-sub-link" to={`/admin/manage-categories/categories/list/${1}`}>
                  {t("sidebar_link_categories")}
                </Link>
              </li>
              <li className={`nav-sub-item ${loc.pathname.includes("/manage-categories/sub-categories") ? " active" : ""}`}>
                <Link className="nav-sub-link" to={`/admin/manage-categories/sub-categories/list/${1}`}>
                  {t("sidebar_link_sub_categories")}
                </Link>
              </li>
            </ul>
          </li>

          {/* // ) : null} */}
          {/* Cms section end */}

          {/* testimonial management section end */}
          {/* <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/testimonial-management")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/testimonial-management/testimonial/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-comment-dots sidemenu-icon"></i>
                <span className="sidemenu-label">
                {t("sidebar_link_testimonials")}
                </span>
              </Link>
            </li> */}
          {/* testimonial management section end */}

          {/* FAQ management section end */}
          <li className={`nav-item ` + (loc.pathname.includes("/faq") ? "show active" : "")}>
            <Link className="nav-link" to={`/admin/faq/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">{t("FAQ")}</span>
            </Link>
          </li>

          <li className={`nav-item ` + (loc.pathname.includes("/inquiry") ? "show active" : "")}>
            <Link className="nav-link" to={`/admin/inquiry/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">Inquiry</span>
            </Link>
          </li>

          <li className={`nav-item ` + (loc.pathname.includes("/transactions") ? "show active" : "")}>
            <Link className="nav-link" to={`/admin/transactions/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">Transactions</span>
            </Link>
          </li>

             {/* Subscription section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/subscription") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-shopping-cart sidemenu-icon" ></i>
              <span className="sidemenu-label">Subscriptions</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/subscription/subscription-plan")
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/subscription/subscription-plan/list/${1}`}
                >
                  Subscription plans
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes(
                    "/subscription/user-subscription-plan/list"
                  )
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/subscription/user-subscription-plan/list/${1}`}
                >
                  {t("User Subscription")}
                </Link>
              </li>
            </ul>
          </li>

          <li className={`nav-item ` + (loc.pathname.includes("/refer-and-earn") ? "show active" : "")}>
            <Link className="nav-link" to={`/admin/refer-and-earn/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">Refers</span>
            </Link>
          </li>

          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/reports") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-question-circle sidemenu-icon" ></i>
              <span className="sidemenu-label">Reports</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/reports/revenue-reports/list")
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/reports/revenue-reports/list/${1}`}
                >
                  Revenue reports
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/admin/reports/users-engagement-report/list")
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/reports/users-engagement-report/list/${1}`}
                >
                  User Engagement reports
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/admin/reports/redemption-report/list")
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/reports/redemption-report/list/${1}`}
                >
                  Redemption reports
                </Link>
              </li>
              {/* <li
                className={`nav-sub-item ${
                  loc.pathname.includes(
                    "/subscription/user-subscription-plan/list"
                  )
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/subscription/user-subscription-plan/list/${1}`}
                >
                  {t("User Subscription")}
                </Link>
              </li> */}
            </ul>
          </li>
          {/* Subscription section end */}

          {/* FAQ management section end */}

          {/* <li className={`nav-item ` + (loc.pathname.includes("/inquiry") ? "show active" : "")}>
            <Link className="nav-link" to={`/admin/inquiry/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Inquiries")}</span>
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
